import React, { useState } from "react";
import Modal from "../Modal";
// hero styles
import "./Hero.css";
import Button from "../shared/Button";

const Hero = () => {
  // adding the modal pop-up

  const [show, setShow] = useState(false);

  // function to show the modal
  const showModal = () => {
    setShow(true);
  };

  // function to close the modal
  const closeModal = () => {
    setShow(false);
  };
  return (
    <div className="hero-container">
      <div className="hero-description">
        <p>Being healthy now is so simple</p>
        <h1>We Take Care Of Your Health</h1>
        <span>
          We provide the most full medical services, so every person could have
          the opportunity to receive qualitative medical help.
        </span>
        <Modal show={show} handleClose={closeModal}></Modal>
        <Button className="btn" onClick={showModal}>
          <span>+</span>
          Request an appointment
        </Button>
      </div>
    </div>
  );
};

export default Hero;
